var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiux2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.92 391.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccf;}.cls-2{fill:#8380f9;}.cls-3{fill:#5446cf;}.cls-4{fill:#6c5ef1;}.cls-5{fill:#2a3554;}.cls-6{fill:#161631;}.cls-15,.cls-7{fill:#fff;}.cls-8{fill:#e3e3ff;}.cls-9{fill:#f5ab86;}.cls-10{fill:#161642;}.cls-11{fill:#f88265;}.cls-12{fill:#f8664d;}.cls-13{fill:#b6b6ef;}.cls-14{fill:#445279;}.cls-15{opacity:0.5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.17,145c88.94-31.32,180.37,12.09,125.17,109.23-53.69,94.49,25.37,119.53,25.37,119.53L103.35,372c-65.8-23.81-121.79-127.34-60.21-159.9,0,0,39.19-7.54,42.71-34.89s-12.07-49.77,13.07-67,67.41-12.46,106.58,21C235.67,157.06,276.17,145,276.17,145Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 227.13,
    cy: 377.98,
    rx: 221.25,
    ry: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.83,41.85a3.79,3.79,0,0,1-1.12,2.69A3.75,3.75,0,0,1,123,45.66H41.58a3.81,3.81,0,0,1,0-7.62h3.85A9.93,9.93,0,0,1,61.59,35a13.78,13.78,0,0,1,11.89-6.8,13.92,13.92,0,0,1,4,.59,15.76,15.76,0,0,1,29.11,3.18,9.93,9.93,0,0,1,14,6.1H123A3.83,3.83,0,0,1,126.83,41.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421.41,44.59a3.84,3.84,0,0,1-3.81,3.81H336.16a3.8,3.8,0,0,1-2.69-6.5,3.75,3.75,0,0,1,2.69-1.12H340a9.92,9.92,0,0,1,16.16-3.08,13.78,13.78,0,0,1,11.89-6.8,13.92,13.92,0,0,1,4,.59,15.76,15.76,0,0,1,29.11,3.18,9.93,9.93,0,0,1,14,6.11h2.45A3.82,3.82,0,0,1,421.41,44.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.39,53.87a3.84,3.84,0,0,1-3.81,3.81H204.14a3.81,3.81,0,0,1,0-7.62H208A9.92,9.92,0,0,1,224.14,47,13.8,13.8,0,0,1,236,40.18a13.49,13.49,0,0,1,4,.6A15.76,15.76,0,0,1,269.15,44a9.93,9.93,0,0,1,14,6.1h2.45A3.83,3.83,0,0,1,289.39,53.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430,101.63a5.47,5.47,0,1,1-5.46,5.47A5.47,5.47,0,0,1,430,101.63Zm0,1.72a3.75,3.75,0,1,0,3.76,3.75A3.76,3.76,0,0,0,430,103.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M424.41,73.85A5.47,5.47,0,1,1,419,79.32,5.47,5.47,0,0,1,424.41,73.85Zm0,1.71a3.76,3.76,0,1,0,3.75,3.76A3.76,3.76,0,0,0,424.41,75.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M407.79,66.15a.85.85,0,0,0,.85.86h3.79a.86.86,0,0,0,0-1.72h-3.79A.86.86,0,0,0,407.79,66.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M401.17,66.15A.85.85,0,0,0,402,67h3.78a.86.86,0,1,0,0-1.72H402A.86.86,0,0,0,401.17,66.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M406.37,60.84v3.4a.86.86,0,1,0,1.71,0v-3.4a.86.86,0,0,0-1.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M406.37,68.06v3.4a.86.86,0,1,0,1.71,0v-3.4a.86.86,0,0,0-1.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414,95.35a.86.86,0,0,0,.86.85h3.78a.86.86,0,1,0,0-1.71h-3.78A.86.86,0,0,0,414,95.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M407.34,95.35a.85.85,0,0,0,.85.85H412a.86.86,0,1,0,0-1.71h-3.78A.85.85,0,0,0,407.34,95.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.53,90v3.4a.86.86,0,0,0,1.72,0V90a.86.86,0,0,0-1.72,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.53,97.26v3.39a.86.86,0,0,0,1.72,0V97.26a.86.86,0,0,0-1.72,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.28,95.15a5.47,5.47,0,1,1-5.46-5.47A5.47,5.47,0,0,1,46.28,95.15Zm-1.71,0a3.75,3.75,0,1,0-3.75,3.75A3.76,3.76,0,0,0,44.57,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.65,61a5.46,5.46,0,1,1-6.59-4A5.47,5.47,0,0,1,69.65,61Zm-1.66.4a3.75,3.75,0,1,0-2.76,4.53A3.75,3.75,0,0,0,68,61.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.47,88.1a.85.85,0,0,0-.86.86v3.78a.86.86,0,1,0,1.71,0V89A.85.85,0,0,0,63.47,88.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.47,81.48a.86.86,0,0,0-.86.86v3.78a.86.86,0,1,0,1.71,0V82.34A.86.86,0,0,0,63.47,81.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.77,86.68H65.38a.86.86,0,1,0,0,1.72h3.39a.86.86,0,0,0,0-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.56,86.68h-3.4a.86.86,0,1,0,0,1.72h3.4a.86.86,0,0,0,0-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.43,75.1a.86.86,0,0,0-.86.86v3.78a.86.86,0,1,0,1.71,0V76A.86.86,0,0,0,44.43,75.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.43,68.49a.85.85,0,0,0-.86.85v3.78a.86.86,0,1,0,1.71,0V69.34A.85.85,0,0,0,44.43,68.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.73,73.68H46.34a.86.86,0,1,0,0,1.72h3.39a.86.86,0,0,0,0-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.52,73.68h-3.4a.86.86,0,1,0,0,1.72h3.4a.86.86,0,0,0,0-1.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.56,
    y: 289.71,
    width: 46.24,
    height: 88.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180,357.86H295.48a18.74,18.74,0,0,1,18.74,18.74v2.8a0,0,0,0,1,0,0H161.31a0,0,0,0,1,0,0v-2.8A18.74,18.74,0,0,1,180,357.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "260.8 292.42 214.56 301.23 214.56 289.71 260.8 289.71 260.8 292.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 80.74,
    y: 81.35,
    width: 310.13,
    height: 208.36,
    rx: 5.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M382.65,95.72V275.34a6.05,6.05,0,0,1-6,6.05H95a5.59,5.59,0,0,1-2.09-.39A6,6,0,0,1,89,275.34V95.72a6,6,0,0,1,6-6H376.6a6,6,0,0,1,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M382.65,95.72v8.94H89V95.72a6,6,0,0,1,6-6h281.6A6,6,0,0,1,382.65,95.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M128.78,97.29h0a2,2,0,0,0,2,2H329.12a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2H130.76A2,2,0,0,0,128.78,97.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.16,97.29v1.47a.54.54,0,0,1-.82.47l-1.27-.73-1.27-.74a.54.54,0,0,1,0-.94l1.27-.74,1.27-.73a.54.54,0,0,1,.82.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.78,97.29v1.47a.54.54,0,0,0,.82.47l1.27-.73,1.27-.74a.54.54,0,0,0,0-.94l-1.27-.74-1.27-.73a.54.54,0,0,0-.82.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.61,97.17a2.94,2.94,0,1,1-2.94-2.93A2.94,2.94,0,0,1,359.61,97.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.75,97.17a2.94,2.94,0,1,1-2.93-2.93A2.94,2.94,0,0,1,348.75,97.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.46,97.17a2.94,2.94,0,1,1-2.93-2.93A2.94,2.94,0,0,1,370.46,97.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 102.11,
    y: 124.35,
    width: 24.98,
    height: 113.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.11,
    y: 124.35,
    width: 24.98,
    height: 7.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 347.12,
    y: 181.85,
    width: 24.98,
    height: 55.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 347.12,
    y: 181.85,
    width: 24.98,
    height: 7.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 347.69,
    y: 124.74,
    width: 24.98,
    height: 32.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 347.69,
    y: 124.74,
    width: 24.98,
    height: 7.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 138.38,
    y: 124.75,
    width: 198.76,
    height: 112.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 227.89,
    y: 156.17,
    width: 61.42,
    height: 61.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 207.32,
    cy: 177.49,
    r: 30.65,
    transform: "translate(-14.26 336.81) rotate(-76.28)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.71 227.84 184.27 227.84 201.99 197.14 219.71 166.45 237.43 197.14 255.15 227.84 219.71 227.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 138.38,
    y: 124.75,
    width: 198.76,
    height: 9.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.65,230.5a.47.47,0,0,1-.47-.48V141a.47.47,0,0,1,.47-.47.48.48,0,0,1,.48.47V230A.48.48,0,0,1,168.65,230.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.07,141.19a1.44,1.44,0,1,1-1.44-1.44A1.43,1.43,0,0,1,170.07,141.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.07,230a1.44,1.44,0,1,1-1.44-1.43A1.43,1.43,0,0,1,170.07,230Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.57,230.5a.47.47,0,0,1-.48-.48V141a.48.48,0,0,1,1,0V230A.47.47,0,0,1,306.57,230.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308,141.19a1.44,1.44,0,1,1-1.44-1.44A1.43,1.43,0,0,1,308,141.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308,230a1.44,1.44,0,1,1-1.44-1.43A1.43,1.43,0,0,1,308,230Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.24,343.61l-5.79,7.45A12,12,0,0,0,13.8,357l6.93-8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.84,354.65s2.71-.56,3.64.34,3.25,13.17,5.43,15.85,0,4.11-1.35,4.65S0,357.58,0,357.58s4.75-6.31,7-7.54S10.41,353.35,12.84,354.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.28,361.44a.49.49,0,0,1-.26-.27.46.46,0,0,1,.29-.59,7.81,7.81,0,0,1,3.62-.37,3.31,3.31,0,0,1,2.52,2.25.47.47,0,0,1-.36.56.5.5,0,0,1-.59-.35,2.34,2.34,0,0,0-1.79-1.55,7,7,0,0,0-3.07.33A.5.5,0,0,1,13.28,361.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.06,359.54a.51.51,0,0,1-.26-.26.46.46,0,0,1,.29-.6,7.7,7.7,0,0,1,3.62-.36,3.26,3.26,0,0,1,2.52,2.24.47.47,0,0,1-.36.56.49.49,0,0,1-.59-.35,2.34,2.34,0,0,0-1.79-1.55,7,7,0,0,0-3.07.33A.45.45,0,0,1,13.06,359.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M14.06,363.47a.49.49,0,0,1-.26-.27.47.47,0,0,1,.29-.6,7.7,7.7,0,0,1,3.62-.36,3.28,3.28,0,0,1,2.52,2.25.47.47,0,0,1-.36.56.49.49,0,0,1-.59-.35,2.32,2.32,0,0,0-1.79-1.55,6.82,6.82,0,0,0-3.07.33A.55.55,0,0,1,14.06,363.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M50.88,242.38l-5.24,49.7a123.35,123.35,0,0,0-11.87,17.3c-4.2,7.65-22.09,35-22.09,35l8.56,7,44.65-50.11,9.87-59.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59,357.91l.88,9.64a12.38,12.38,0,0,0,8.09,1l-.82-11.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.25,367.18s1.7-2.35,3.07-2.27,12.09,8.35,15.73,9,3,3.33,2.33,4.7-28.82.59-28.82.59-1-9.09-.15-11.68S63.42,367.83,66.25,367.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.73,372.13a.46.46,0,0,1-.38,0,.48.48,0,0,1-.22-.65,7.54,7.54,0,0,1,2.35-2.78,3.34,3.34,0,0,1,3.43-.05.48.48,0,0,1-.53.81,2.39,2.39,0,0,0-2.41.08,6.5,6.5,0,0,0-2,2.37A.48.48,0,0,1,71.73,372.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.2,370.86a.46.46,0,0,1-.38,0,.48.48,0,0,1-.22-.65A7.54,7.54,0,0,1,72,367.41a3.34,3.34,0,0,1,3.43-.05.48.48,0,1,1-.52.81,2.39,2.39,0,0,0-2.42.08,6.61,6.61,0,0,0-2,2.37A.46.46,0,0,1,70.2,370.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.75,373.11a.46.46,0,0,1-.38,0,.48.48,0,0,1-.22-.65,7.46,7.46,0,0,1,2.35-2.78,3.32,3.32,0,0,1,3.43-.06.48.48,0,0,1-.53.81,2.39,2.39,0,0,0-2.41.08,6.7,6.7,0,0,0-2,2.37A.48.48,0,0,1,73.75,373.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.69,243.82S34.13,281,47.71,301c0,0,2,19.49,5.49,29.87,1.52,4.54,5.37,31.59,5.37,31.59l1.67-.24,1-.15L68.64,361,65.31,296.6,49,245.76l-21.07-1.62-1.12-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M26.8,244.06,49.9,301c0,.07,3.45,15.53,5.39,26.4,1.74,9.67,4.27,26.51,5,34.79l1-.15c-.69-8.36-3.17-24.92-4.95-34.82-2-10.88-5.4-26.36-5.43-26.52L27.92,244.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.27,190.57c3,11.23,11.4,19.5,11.4,19.5,4.87,2.49,17.91,7.74,22.51,7a37.8,37.8,0,0,1,.83-9.15c-6.24-.43-17.26-7.72-17.26-7.72C81.42,181.59,80.53,161,80.53,161,73.8,167.61,73.27,190.57,73.27,190.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.84,230.63c0,.35-.07.71-.1,1.06-.57,6.35-1,11.27-1.18,13.69a102.64,102.64,0,0,0,18.11,4.91l.83.14.44.07,1,.15,1.1.16a97.16,97.16,0,0,0,12.54.91c.85,0,1.7,0,2.55,0h.16l.66,0h.39a103.1,103.1,0,0,0,14.83-1.5c.11-1.1.26-2.73.45-4.78,0-.38.07-.77.11-1.18h0c.26-2.94.58-6.59.92-10.72l.09-1.07c.23-2.75.47-5.7.71-8.77l.09-1.07c.24-3.15.5-6.42.74-9.75.15-2,.3-4.08.45-6.13s.29-4.16.43-6.23l.09-1.35c1.3-19.55,2.12-37.57.94-39.69-.82-1.47-2.83-3.3-5.22-5.17l-.9-.69c-1-.77-9.59-4.58-10.65-5.35l-9.29-1.5c-.06,0-9.27,2.23-9.33,2.25l-1.22.56a53.59,53.59,0,0,0-9,4.88c-.29.23-.56.45-.79.67a5.76,5.76,0,0,0-.49.52,3,3,0,0,0-.4.79c-1.51,4-3.57,20.1-5.47,37.64-.14,1.26-.27,2.53-.4,3.79l-.18,1.68-.12,1.15-.06.58c-.1.95-.2,1.9-.29,2.85-.08.7-.15,1.4-.22,2.1C25.28,215,24.47,223.62,23.84,230.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.25,199.39A42.71,42.71,0,0,0,66,210.12a.56.56,0,0,0,.7-.5h0a.57.57,0,0,0-.43-.6A41.54,41.54,0,0,1,47,198.56a.56.56,0,0,0-.95.34v0A.55.55,0,0,0,46.25,199.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.15,190.78v0a.5.5,0,0,0,.08.26c.31.49.66,1,1.06,1.54a22.72,22.72,0,0,0,13.34,8.31l.13,0a.52.52,0,0,0,.49-.41.53.53,0,0,0-.39-.62,21.39,21.39,0,0,1-13.75-9.42A.52.52,0,0,0,46.15,190.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.2,167.21h0a.51.51,0,0,0,.63.45,36.8,36.8,0,0,0,14.3-7,35.17,35.17,0,0,0,6.8-6.92.52.52,0,1,0-.86-.58A37.32,37.32,0,0,1,46.6,166.66.52.52,0,0,0,46.2,167.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.15,122.94s5.39-1.35,5.24-5.46c-.12-3.5-2.55-1.73-2-4.4s-.49-5.46-3.67-4.76c-2.1.46-4.27,1.34-7.87-.4-5.2-2.5-6.71,1.09-10.73,1-5.94-.17-7.67,3.29-7.84,6.06S48,121.32,48,121.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M71.73,128.79s2.46-2.72,3.87-.15-1.54,9.49-5.38,7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M71.3,133.9a.33.33,0,0,0,.34-.22,5.25,5.25,0,0,1,3.21-2.84.33.33,0,0,0,.24-.41.34.34,0,0,0-.42-.24A5.85,5.85,0,0,0,71,133.44a.34.34,0,0,0,.2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M73.7,133a.31.31,0,0,0,.19,0,.33.33,0,0,0,.15-.45,3.14,3.14,0,0,0-1.18-1.14.34.34,0,0,0-.33.59,2.31,2.31,0,0,1,.9.86A.34.34,0,0,0,73.7,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.13,126.73s-1.92-3.12-3.77-.85-.2,9.62,4,8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M48.64,131.83a.33.33,0,0,1-.3-.27,5.24,5.24,0,0,0-2.65-3.38.34.34,0,0,1-.15-.45.34.34,0,0,1,.45-.16,5.85,5.85,0,0,1,3,3.86.33.33,0,0,1-.27.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M46.44,130.51a.29.29,0,0,1-.18-.07.33.33,0,0,1-.06-.47,3,3,0,0,1,1.36-.91.34.34,0,0,1,.43.21.33.33,0,0,1-.21.43,2.58,2.58,0,0,0-1.05.68A.31.31,0,0,1,46.44,130.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M53.82,140.64l-.65,7.1s1.79,3.81,4.63,4.32,5.69-2.62,5.69-2.62l.67-7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M53.82,140.64l-.29,3.15c1.73,2.31,5.09,3.15,10.21,2.87l.42-4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48,121.72a68.42,68.42,0,0,0,.11,9.05h0s0,0,0,0h0c.07.69.16,1.33.26,1.92.07.34.14.7.22,1.07,1.21,5.43,4.41,13.43,14.53,10.83,4.26-1.09,6.8-5.16,8.32-9.69.09-.27.17-.53.25-.79l.15-.5.07-.25s0-.07,0-.08v0a50.4,50.4,0,0,0,1.58-9.66A7.43,7.43,0,0,0,70.32,117c-5.85-4.06-12.49-3.35-16.93-2.09A7.41,7.41,0,0,0,48,121.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.8,127.52c-.07.75.26,1.4.75,1.45s.92-.54,1-1.29-.26-1.41-.74-1.46S54.87,126.76,54.8,127.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.4,128.48c-.07.76.26,1.41.75,1.46s.92-.54,1-1.3-.26-1.41-.74-1.45S65.47,127.73,65.4,128.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.38,123s3.59-1.51,6.41-.37l-.25,1.56s-4.1-.26-6.14.62A2.68,2.68,0,0,1,52.38,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.64,124.4s-3.39-2-6.35-1.2l.05,1.58s4.12.28,6,1.43A2.75,2.75,0,0,0,69.64,124.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M59.79,134.16a3.62,3.62,0,0,1-1.19-.37.35.35,0,0,1-.15-.46.34.34,0,0,1,.46-.14,2,2,0,0,0,1.34.25.36.36,0,0,0,.2-.3c.22-1.17.26-5.15.26-5.19a.34.34,0,0,1,.34-.33.34.34,0,0,1,.34.34,50.13,50.13,0,0,1-.28,5.31,1,1,0,0,1-.57.78A1.45,1.45,0,0,1,59.79,134.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.8,137.12c-.37,1.26-1.44,3.55-4.31,3.29s-3.48-2.5-3.62-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48,121.72a70.17,70.17,0,0,0,.1,9.05l1.52,0s-.15-2.36-.18-3.9-.06-4.39,1.27-4.63.86-3.54,2.79-4.78,6-1.26,8.48.61,5.66.4,6.85.79,2.71,2.23,2.12,3.77.66,2.61.84,4.27-1.27,5.95-1.27,5.95l1.42.42a51.24,51.24,0,0,0,1.58-9.65A7.45,7.45,0,0,0,70.33,117c-5.86-4.06-12.5-3.35-16.94-2.09A7.41,7.41,0,0,0,48,121.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.59,129a4.09,4.09,0,1,1,3.7,4.44A4.1,4.1,0,0,1,62.59,129Zm.63.05A3.45,3.45,0,1,0,67,125.93,3.47,3.47,0,0,0,63.22,129.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.44,128a4.1,4.1,0,1,1,3.71,4.45A4.11,4.11,0,0,1,51.44,128Zm.64.06a3.45,3.45,0,1,0,3.75-3.13A3.46,3.46,0,0,0,52.08,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.16,126.59a.49.49,0,0,1-.15.66,5.43,5.43,0,0,0-2.61,1,.29.29,0,0,1-.23.07.29.29,0,0,1-.22-.11.33.33,0,0,1,0-.45A6,6,0,0,1,73.16,126.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.46,126.6a.32.32,0,0,1-.28.12.28.28,0,0,1-.17-.07,10.08,10.08,0,0,0-4.13-1.87.43.43,0,0,1,0-.64,10.39,10.39,0,0,1,4.53,2A.33.33,0,0,1,52.46,126.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.46,127.79a2.55,2.55,0,0,1,1.85-.87,2.32,2.32,0,0,1,1.57,1.18l.57-.3a3,3,0,0,0-2.09-1.52A3.15,3.15,0,0,0,59,127.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.13,245.15l-1.77-3.62a6,6,0,0,1,2.75-7.95l102.6-49.92,7,14.32L48.08,247.9A6,6,0,0,1,40.13,245.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 149.92,
    y: 173.73,
    width: 15.92,
    height: 23.77,
    transform: "translate(255.72 -37.56) rotate(64.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.1,183.56a31.47,31.47,0,0,1-21,4l-7-14.32s5.45-9.55,14.18-11.63a24.92,24.92,0,0,1,5.06-.72h0c11.84-.35,10.07,10.9,28-1.78C212.32,159.13,206.71,175.5,193.1,183.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.1,183.56c-6-.91-5.64-11.16-4.58-15.2,1.27-4.83-4-7.35-4.18-7.45,11.84-.35,10.07,10.9,28-1.78C212.32,159.13,206.71,175.5,193.1,183.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.56,227.23l1.48.68a3.57,3.57,0,0,0,3.81-.62,19.34,19.34,0,0,1,1.69-1.41c1.12-.61,3.71-1.29,4.44-1s0,1.53-.77,1.88a12.89,12.89,0,0,0-2.68,1.34c-.8.62,2.33,4,3.72,5.15s4.56,1.53,4.23,3-2.5.67-2.5.67.07,1.46-2.1,1.64a1.74,1.74,0,0,1-1.61,1.4,2,2,0,0,1-2,1.31c-1.47-.21-6-.89-11.75-9.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59,226.42S38,209.18,31.29,200.1c0,0,1.21-10.81,2.53-19.46a79.36,79.36,0,0,0,.8-16.94,30.18,30.18,0,0,0-1.31-8.09s-6.1,1.79-10.09,22.11a208.37,208.37,0,0,0-3.39,24.41,9.24,9.24,0,0,0,2,6.4c4.45,5.66,15.62,18,32,23.88C53.77,232.41,58.13,229,59,226.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121.1,210.5s-3.22-2.61-5.17-2.51,1.85,4.32,1.85,4.32-4.62-5.05-6-4.18,2.93,5.9,2.93,5.9-3.65-2.94-4.8-2.38,1.87,4.37,1.87,4.37-3.13-2-4-1.72,1.25,3.84,2.94,5.17,3-1.27,3-1.27,2.38-.95,2.53-2.14c0,0,2.33-.6,2.92-1.85C119.06,214.21,122.54,212.82,121.1,210.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 398.77,
    y: 215.64,
    width: 19.27,
    height: 154.6,
    transform: "translate(-27.95 43.53) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 402.11,
    y: 216.23,
    width: 1.28,
    height: 154.6,
    transform: "translate(-28.04 42.95) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 407.76,
    y: 215.64,
    width: 1.28,
    height: 154.6,
    transform: "translate(-27.95 43.53) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 413.4,
    y: 215.06,
    width: 1.28,
    height: 154.6,
    transform: "translate(-27.86 44.11) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 406.3,
    y: 361.77,
    width: 19.27,
    height: 8.08,
    transform: "translate(-35.39 44.68) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.76,370.82l.24,2.29a9.64,9.64,0,0,0,10.57,8.6h0a9.64,9.64,0,0,0,8.6-10.58l-.24-2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "410.04 215.06 390.87 217.04 395.24 203.58 396.14 200.78 398.71 192.88 402.57 200.44 404.08 203.39 410.04 215.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M402.57,200.44a9.58,9.58,0,0,1-3,.76,6.93,6.93,0,0,1-3.43-.42l2.57-7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.76,45.21s-5.55,25.05-12.64,33.18H276.5s7.54-5.69,7.81-14.5S278.76,45.21,278.76,45.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.46,36.92q-10.24,3.61-20.54,7a7.06,7.06,0,0,1-8.73-4l0,0c-2.29-5.43-7-11.63-8-14.43v0c-.21-.45-.39-.91-.56-1.37-2.46-6.7-2.7-20.48,12.59-23.74,0,0,12.6-2.94,18.21,8.4,0,0,2.52,5.25,4.31,9.07,2,4.35,3.6,5.77,5,6.83a7,7,0,0,1-2,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.61,54c-.41,3.54-1.53,7.13,0,12.77a23.44,23.44,0,0,0,2.6,5.67,4.36,4.36,0,0,0,.24.41l.09.75c.91,6.28.67,2.95.57,8.12h32.53l-.76-40.9-10.27-.9h0l-1.77-.16h-.1l-2.77-.25-.73-.06a26.07,26.07,0,0,0-10.95,1.7l-.12,0-1.54.6-.09,0-1.51.57-7.23,2.8C279.13,46.84,280.28,52.38,280.61,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.42,72.87l.09.75c1.78.38,7.38,1.17,16.89-1.11,1.23-.3,2.53-.64,3.9-1.05a.52.52,0,0,0,.35-.66.51.51,0,0,0-.65-.35c-13.72,4.07-20.73,2-20.8,2h0C283.26,72.59,283.33,72.73,283.42,72.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M274.43,24.5s-3-1.9-3.8.84,3.72,8.4,7,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.73,31a.75.75,0,0,1-.45.94.74.74,0,0,1-.49-1.39A.75.75,0,0,1,275.73,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M276,29.11a.32.32,0,0,1-.38-.11,5.15,5.15,0,0,0-3.79-1.81.32.32,0,0,1-.32-.33.34.34,0,0,1,.35-.32,5.76,5.76,0,0,1,4.32,2.08.32.32,0,0,1-.09.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M273.49,28.89a.3.3,0,0,1-.19,0,.31.31,0,0,1-.24-.39,3.08,3.08,0,0,1,.87-1.35.34.34,0,0,1,.48,0,.31.31,0,0,1,0,.46,2.65,2.65,0,0,0-.68,1A.3.3,0,0,1,273.49,28.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M295.31,32.25l2.83,7.91s-2.67,4.15-5.45,5.42-5-1.75-5-1.75l-2.63-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M295.59,33l1.13,3.16C295.56,39,292.41,41,287.08,42l-1.71-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M274.25,28c.36.73.75,1.47,1.16,2.2,2.75,4.82,8,9.21,12.43,8.68,9.59-1.16,10.79-9.45,10.37-15.09,0-.63-.58-1.18-.69-1.9a53.85,53.85,0,0,0-.78-5.61c-.34-1.28-.71-2.53-1.05-3.66a7.71,7.71,0,0,0-7-5.51c-4.66-.17-11.31.76-15.95,6.3a7.73,7.73,0,0,0-1.36,7.47A56.57,56.57,0,0,0,274.25,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M286.5,28.06a.35.35,0,0,0,.23-.4.36.36,0,0,0-.42-.3l-1.26.22.08-4.92a.35.35,0,0,0-.36-.37.36.36,0,0,0-.37.36l-.09,5.81,2.13-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.57,18.06c-2.91,2.82-.33,6.55-.77,9,0,.16-.09.21-.2.17a58.11,58.11,0,0,1-3-7.25,7.88,7.88,0,0,1,1.51-7.66c4.93-5.72,11.93-6.75,16.82-6.63a7.87,7.87,0,0,1,7.34,5.57c.35,1.15.72,2.43,1.06,3.73-.45.55-1.8,1.21-1.53,2.16.72,2.5,1.2,4.22.63,4.25-.95.06-2.54-2.71-2.24-5,0,0-1.25-1-4.93-1.1a65.8,65.8,0,0,1-9.55-1,8,8,0,0,1-2.89-1.21A7.79,7.79,0,0,1,274.57,18.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.41,23.76c.27.76.1,1.51-.39,1.69s-1.09-.31-1.36-1.07-.1-1.51.38-1.68S280.14,23,280.41,23.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M289.85,20.39c.28.75.1,1.51-.38,1.68s-1.09-.3-1.36-1.06-.1-1.52.38-1.69S289.58,19.63,289.85,20.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.89,21.31a18.15,18.15,0,0,1,3.53-1.61.67.67,0,0,1,.89.39h0a.61.61,0,0,1-.49.63,20.49,20.49,0,0,0-4.88,2.09.72.72,0,0,1,.07-.64A2.23,2.23,0,0,1,275.89,21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290,16.45a18.49,18.49,0,0,0-3.76.94.66.66,0,0,0-.45.86h0a.58.58,0,0,0,.77.18,20.18,20.18,0,0,1,5.12-1.39c0-.2-.22-.35-.45-.46A2.23,2.23,0,0,0,290,16.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M283.41,31.48a4.16,4.16,0,0,0,5.19,2,4,4,0,0,0,2.72-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M289.3,35.59a3.61,3.61,0,0,1-1.75.1.37.37,0,0,1-.28-.43.37.37,0,0,1,.43-.27h0a2.86,2.86,0,0,0,1.36-.08,3,3,0,0,0,1.17-.83.36.36,0,0,1,.5,0,.35.35,0,0,1,0,.51A3.62,3.62,0,0,1,289.3,35.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M295.79,16.84s1.37-3.81,3.56-2.2,2.41,8.6-1.64,8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M300,22.31a.72.72,0,0,1-.45.94.73.73,0,0,1-.94-.44.74.74,0,0,1,.45-.94A.73.73,0,0,1,300,22.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M297.78,20.75a.32.32,0,0,0,.21-.32,4.87,4.87,0,0,1,1.59-3.64.32.32,0,0,0,0-.44.33.33,0,0,0-.45,0,5.44,5.44,0,0,0-1.81,4.17.32.32,0,0,0,.34.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M299.46,19.05a.33.33,0,0,0,.14-.1.32.32,0,0,0-.06-.44,2.85,2.85,0,0,0-1.43-.5.32.32,0,1,0-.05.63,2.21,2.21,0,0,1,1.1.37A.3.3,0,0,0,299.46,19.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.39,74.84,251,74.88l.27,135.78L359.28,81Zm-96.33,17,60,0-59.85,71.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.8 184.31 252.79 182.97 258.57 182.97 258.58 184.3 252.8 184.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.78 176.58 252.78 175.25 258.56 175.24 258.56 176.58 252.78 176.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.76 168.86 252.76 167.52 258.54 167.52 258.55 168.85 252.76 168.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.75 161.13 252.75 159.8 258.53 159.79 258.53 161.13 252.75 161.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.73 153.41 252.73 152.07 258.51 152.07 258.51 153.41 252.73 153.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.72 145.68 252.72 144.35 258.5 144.35 258.5 145.68 252.72 145.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.7 137.96 252.7 136.62 258.48 136.62 258.48 137.96 252.7 137.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.69 130.23 252.69 128.9 258.46 128.9 258.47 130.23 252.69 130.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.67 122.51 252.67 121.18 258.45 121.17 258.45 122.51 252.67 122.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.66 114.79 252.65 113.45 258.43 113.45 258.44 114.78 252.66 114.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.64 107.06 252.64 105.73 258.42 105.72 258.42 107.06 252.64 107.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.63 99.34 252.62 98 258.4 98 258.41 99.33 252.63 99.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.61 91.61 252.61 90.28 258.39 90.28 258.39 91.61 252.61 91.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "252.59 83.89 252.59 82.55 258.37 82.55 258.38 83.89 252.59 83.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "364.39 74.83 251.02 74.88 251.03 81.01 359.28 80.97 364.39 74.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M293.48,89.39l-1.53.1a3.34,3.34,0,0,1-3.14-1.81,19.6,19.6,0,0,0-1-1.8c-.78-.9-2.83-2.36-3.56-2.36s-.51,1.35,0,1.9a12.4,12.4,0,0,1,1.91,2.07c.49.81-3.39,2.79-5,3.29s-4.51-.16-4.69,1.2,2,1.42,2,1.42-.54,1.25,1.3,2.13a1.66,1.66,0,0,0,1,1.77,1.84,1.84,0,0,0,1.33,1.82c1.36.3,5.6,1.22,13.41-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.93,95.77s13.15-.17,33.13-12.25l3.09-2h0c.41-6.14-3.47-16.47-6.19-25.5-1.79-6-4.15-13.17-9.11-15.19a19,19,0,0,0-2.59,7.43,38.24,38.24,0,0,0,2.13,13.41c1.4,4.17,2.38,9.51,3.66,13.68l.12.57c-.16,0-5.44,3-12.65,6.29-7.91,3.64-14.19,7.24-14.19,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M277.33,75.2s-.92,3.91-2.48,5-1.14-4.4-1.14-4.4-.54,6.61-2.14,6.78-1.27-6.26-1.27-6.26S269.25,80.73,268,81s-1.16-4.46-1.16-4.46-1.19,3.42-2.09,3.71-1.33-3.68-.82-5.71,3-.79,3-.79,2.38-.68,3.21.14c0,0,2.14-.92,3.34-.32C273.56,73.56,277.05,72.56,277.33,75.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.88,301.23v26.29H257.76a6.79,6.79,0,0,1-6.79-6.79V308a6.78,6.78,0,0,1,6.79-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M376.88,304.55v19.64H268.8a6.28,6.28,0,0,1-6.28-6.27v-7.08a6.28,6.28,0,0,1,6.28-6.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 273.5,
    y: 308.54,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 273.5,
    y: 313.5,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 273.5,
    y: 318.47,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359.22,327.52v26.29H240.09a6.78,6.78,0,0,1-6.78-6.79V334.3a6.77,6.77,0,0,1,6.78-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M359.22,330.84v19.64H251.13a6.27,6.27,0,0,1-6.27-6.27v-7.08a6.27,6.27,0,0,1,6.27-6.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 255.83,
    y: 334.83,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 255.83,
    y: 339.8,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 255.83,
    y: 344.76,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.66,353.81V380.1H263.53a6.79,6.79,0,0,1-6.78-6.79V360.59a6.79,6.79,0,0,1,6.78-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M382.66,357.13v19.64H274.57a6.27,6.27,0,0,1-6.27-6.27v-7.08a6.28,6.28,0,0,1,6.27-6.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.27,
    y: 361.12,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.27,
    y: 366.09,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.27,
    y: 371.05,
    width: 103.38,
    height: 1.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.5,58.27l.48-6.1-5.56-.44a13.84,13.84,0,0,0-1.18-3.53l4.49-3.84-4-4.65-4.36,3.73a13.65,13.65,0,0,0-3.91-2.15l.44-5.56-6.1-.48-.42,5.33a13.57,13.57,0,0,0-5.22,1.67l-3.73-4.36-4.65,4,3.84,4.49a13.66,13.66,0,0,0-1.71,3.31l-5.57-.44-.47,6.1,5.32.42A13.84,13.84,0,0,0,153.89,61l-3.81,3.25,4,4.65L158,65.5a13.4,13.4,0,0,0,4.3,2l-.42,5.33,6.1.48.44-5.57a13.6,13.6,0,0,0,4.81-1.89L177,70.26l4.65-4-4.06-4.76a13.8,13.8,0,0,0,1.61-3.68Zm-13-3.58a5.61,5.61,0,1,1-5.15-6A5.61,5.61,0,0,1,171.49,54.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M165.9,45a9.45,9.45,0,1,0,9.44,9.44A9.44,9.44,0,0,0,165.9,45Zm5.59,9.65a5.61,5.61,0,1,1-5.15-6A5.61,5.61,0,0,1,171.49,54.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.32,136.09a13.49,13.49,0,0,0-3.68,1.61l-4.75-4.06-4,4.65,4.38,3.74a14,14,0,0,0-1.89,4.82l-5.56.43.47,6.1,5.33-.42a13.77,13.77,0,0,0,2,4.31l-3.37,3.94,4.65,4,3.26-3.81a13.57,13.57,0,0,0,5.22,1.67l.42,5.33,6.1-.48-.44-5.57a13.32,13.32,0,0,0,3.31-1.71l4.49,3.84,4-4.65-4.36-3.72a13.66,13.66,0,0,0,1.66-5.23l5.33-.42-.48-6.1-5.56.44a13.65,13.65,0,0,0-2.15-3.91l3.73-4.35-4.65-4L436,137a13.82,13.82,0,0,0-3.53-1.17l-.44-5.57-6.1.48Zm9.19,12.84a5.61,5.61,0,1,1-6-5.15A5.62,5.62,0,0,1,435.51,148.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M429.69,139.92a9.45,9.45,0,1,0,9.44,9.45A9.44,9.44,0,0,0,429.69,139.92Zm5.82,9a5.61,5.61,0,1,1-6-5.15A5.62,5.62,0,0,1,435.51,148.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.7,340.56a4.08,4.08,0,0,1-2.45.91,6.28,6.28,0,0,1-1.73-.11,9.39,9.39,0,0,1-2.36-.8s.38-16.17-6.16-27.31-15.2-26.53-8.27-34.42,18.08,3.08,21.73,21.55S133.7,340.56,133.7,340.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.25,341.47a6.28,6.28,0,0,1-1.73-.11,96.14,96.14,0,0,0-11.06-51.12.86.86,0,0,1,.29-1.19.88.88,0,0,1,1.19.3A97.76,97.76,0,0,1,131.25,341.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.13,314.46c-15.31,24.74-14.25,30.46-14.25,30.46l-2-.36-1.71-.3-2.43-.43c-1.36-11,7.07-57.35,22.09-57.35C173.12,286.48,161.34,306,156.13,314.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.55,300.23c-.15.24-13,23.1-15.68,44.33l-1.71-.3c2.8-21.57,15.74-44.64,15.88-44.89a.87.87,0,0,1,1.51.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127,342.76l-1.76.47-1.69.46-1,.27c.07-.22-.7-2.11-11.47-16.5-4.44-5.94-16.3-21.93-5.43-24.62C115.63,300.39,127.31,334.48,127,342.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.26,343.23l-1.69.46c-3.1-13.86-15.7-30.87-15.84-31.06a.87.87,0,0,1,1.39-1C109.67,312.35,122.06,329.06,125.26,343.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.18,337.9h26.08a4.07,4.07,0,0,1,4.07,4.07v37.38a0,0,0,0,1,0,0H114.11a0,0,0,0,1,0,0V342A4.07,4.07,0,0,1,118.18,337.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.29,330.21l10.06,6.86a2.79,2.79,0,0,0,3.88-.73l17.39-25.5,7.19-10.55-14.68-10-4.26,6.25-20.32,29.8A2.79,2.79,0,0,0,174.29,330.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.87,296.53a38.43,38.43,0,0,0,11.75,14.31l7.19-10.55-14.68-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163,328.88h1.86a4.59,4.59,0,0,1,4.59,4.59v50.21a0,0,0,0,1,0,0h-11a0,0,0,0,1,0,0V333.47a4.58,4.58,0,0,1,4.58-4.58Z",
    transform: "translate(98.58 742.96) rotate(-145.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M189.69,229.75A50,50,0,1,0,259.17,217,49.95,49.95,0,0,0,189.69,229.75ZM196,234.1a42.29,42.29,0,1,1,10.82,58.82A42.34,42.34,0,0,1,196,234.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M189.41,249.48a42.3,42.3,0,1,0,50-32.79,43.11,43.11,0,0,0-6.52-.84,42.33,42.33,0,0,0-43.51,33.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M209.87,221.38,256.13,292A42.19,42.19,0,0,0,270.4,273l-37.48-57.18A42.17,42.17,0,0,0,209.87,221.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M191,243.79l37,56.52a42.09,42.09,0,0,0,14.64-1.62L198.34,231A41.93,41.93,0,0,0,191,243.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiux2);
export default __webpack_public_path__ + "static/media/uiux2.213e73ad01b66c98fb8d56a7e7434278.svg";
export { ForwardRef as ReactComponent };